var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransport = function SvgTransport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 0a3 3 0 0 1 3 3v1h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2h14V6H6a2 2 0 0 1 2-2h3V3a3 3 0 0 1 3-3Zm-4 13a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2h9Zm0-3a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h7Zm0-3a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2h5Z"
  })));
};
export default SvgTransport;